module.exports = __webpack_public_path__ + "static/media/gem.a1f14301.svg";